import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchEnquiryDetails } from "../../redux/actions/enquiriesAction";

export default function EnquiryContainer() {
    const dispatch = useDispatch();
    const { id } = useParams();
    const [data, setData] = useState({});

    useEffect(() => {
        if (id) {
            dispatch(
                fetchEnquiryDetails(id, (res) => {
                    setData({ ...res });
                })
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, dispatch]);

    return {
        data,
    };
}
